import { AbstractFormViewModelController } from '../../infrastructure/implementations/form-viewmodel-controller';
import { ConnectionType, IConnectionDetailsDTO } from '../../api/connections.dao';
import { FormFieldProps, FormVmItemConfigType } from '../../infrastructure/form-viewmodel-controller';
import { TObject } from '../../infrastructure/type-extensions';
import { ConnectionVersion } from '../../constants/common.constants';


/* For now we must implement IConnectionFormViewModelController interface for consistency with usage in ConnectionFormVM */
export class BaseConnectionFormController extends AbstractFormViewModelController {
    public readonly meetingConnectionId: number | null;
    public readonly blueprintId: string | null;
    public readonly type: ConnectionType;
    public readonly isV2PanelistChild: boolean;

    constructor(private readonly connection: IConnectionDetailsDTO, formConfig: FormVmItemConfigType[]) {
        super(connection, `${connection.type} Connection Type`, formConfig);

        this.type = connection.type;
        this.meetingConnectionId = connection.meetingConnectionId || null;
        this.blueprintId = connection.blueprintId;
        this.isV2PanelistChild = connection.connectionVersion === ConnectionVersion.V2 &&
            connection.type === ConnectionType.PanelistLink &&
            !!connection.joinMethodId;
    }

    public getVmFields = () => this.getVmState();

    public isExistingConnection = (): boolean => this.meetingConnectionId !== null || this.isV2PanelistChild;

    public toApiDTO(): IConnectionDetailsDTO {
        const dto: IConnectionDetailsDTO = { type: this.type, blueprintId: this.blueprintId };

        if (this.isExistingConnection()) {
            dto.meetingConnectionId = this.meetingConnectionId;
        }

        return this.getVmState()
            .reduce((_dto, { name, value }) => {
                const booleanValue = typeof value === 'boolean';
                const trimmedValue = booleanValue
                    ? value
                    : String.prototype.trim.call(value || '');

                if (booleanValue || trimmedValue) _dto[name] = trimmedValue;

                return _dto;
            }, dto);
    };

    public getFormFields(keys: TObject<string>): TObject<FormFieldProps> {
        const formFields = {};

        for (const key of Object.values(keys)) {
            formFields[key] = this.getFormFieldPropsByKey(key);
        }

        return formFields;
    }

    public getFormFieldPropsByKey(key: string): FormFieldProps {
        return {
            value: this.getValue(key),
            setValue: value => this.setValue(key, value),
            setTouched: () => this.setValueTouched(key),
            ...this.getValueValidationState(key)
        };
    }

    public getConnectionSnapshot(): IConnectionDetailsDTO {
        return this.connection;
    }
}
